import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Editor, Toolbar} from 'ngx-editor';
import {
    tableSchema,
    tablePlugins,
    insertTableBtn,
    addColAfterBtn,
    addColBeforeBtn,
    delColBtn,
    addRowAfterBtn,
    addRowBeforeBtn,
    delRowBtn,
    delTableBtn,
} from '../shared/editor-table';

@Component({
    selector: 'app-rt-editor',
    templateUrl: './rt-editor.component.html',
    styleUrls: ['./rt-editor.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RtEditorComponent),
            multi: true
        }
    ]
})
export class RtEditorComponent implements ControlValueAccessor, OnInit, OnDestroy {
    @Input() placeholder: string = 'Enter text...';
    @Input() disabled: boolean = false;
    toolbar: Toolbar = [
        ['bold', 'italic'],
        ['underline', 'strike'],
        ['code', 'blockquote'],
        ['ordered_list', 'bullet_list'],
        [{heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6']}],
        ['link'],
        ['text_color', 'background_color'],
        ['align_left', 'align_center', 'align_right', 'align_justify'],
        ['indent', 'outdent', 'horizontal_rule'],
        ['undo', 'redo', 'format_clear'],
        [insertTableBtn, addColAfterBtn, addColBeforeBtn, delColBtn],
        [addRowAfterBtn, addRowBeforeBtn, delRowBtn, delTableBtn],
    ];

    editor: Editor = new Editor();
    html: string = '';

    imgPanelOpen = false;
    imgUrl = '';
    imgWidth = '100';

    onChange = (_: any) => {
    };
    onTouched = () => {
    };

    ngOnInit() {
        this.editor = new Editor({
            schema: tableSchema,
            plugins: tablePlugins,
        });
    }

    ngOnDestroy() {
        this.editor.destroy();
    }

    writeValue(value: any): void {
        this.html = value || '';
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    /*
      setDisabledState?(isDisabled: boolean): void {
        if (isDisabled) this.editor.disable();
        else this.editor.enable();
      }
        */

    onContentChange(value: string) {
        this.html = value;
        this.onChange(value);
    }

    toggleImgPanel(e: MouseEvent) {
        e.preventDefault();
        this.imgPanelOpen = !this.imgPanelOpen;
    }

    closeImgPanel() {
        this.imgPanelOpen = false;
        this.imgUrl = '';
        this.imgWidth = '100';
    }

    insertImage(e: MouseEvent) {
        e.preventDefault();
        const src = this.imgUrl.trim();
        if (!src) return;
        const view = (this.editor as any).view;
        if (!view) return;
        const node = view.state.schema.nodes['image'].create({ src, style: `width: ${this.imgWidth}%;`, alt: '' });
        view.dispatch(view.state.tr.replaceSelectionWith(node));
        view.focus();
        this.closeImgPanel();
    }
}
